/* VoluFine · galerie + bloc d'achat. Règles : la page ne bouge jamais au clic (scrollTo/scrollBy, jamais scrollIntoView),
   un seul appel /cart/add.js (Moon met le lot entier et ouvre son panier), correctif « collant » MoonCart. */ 
(function(){
  function init(root){
    if(!root||root.dataset.ready)return; root.dataset.ready='1';

    /* ---------- galerie ---------- */
    var track=root.querySelector('[data-vf-track]'), th=root.querySelector('[data-vf-thumbs]');
    var slides=track?[].slice.call(track.children):[], thumbs=th?[].slice.call(th.children):[], cur=0;
    var prev=root.querySelector('[data-vf-prev]'), next=root.querySelector('[data-vf-next]');
    function vertical(){ return th && getComputedStyle(th).flexDirection==='column'; }
    function mark(i){
      thumbs.forEach(function(t,k){ t.setAttribute('aria-current',k===i?'true':'false'); });
      var t=thumbs[i];
      if(t&&th){
        if(vertical()){ var tp=t.offsetTop-th.offsetTop; if(tp<th.scrollTop||tp+t.offsetHeight>th.scrollTop+th.clientHeight) th.scrollTo({top:tp-(th.clientHeight-t.offsetHeight)/2,behavior:'smooth'}); }
        else { var l=t.offsetLeft-th.offsetLeft; if(l<th.scrollLeft||l+t.offsetWidth>th.scrollLeft+th.clientWidth) th.scrollTo({left:l-(th.clientWidth-t.offsetWidth)/2,behavior:'smooth'}); }
      }
      if(prev)prev.disabled=i===0; if(next)next.disabled=i===slides.length-1;
    }
    function go(i,smooth){ if(!slides.length)return; i=Math.max(0,Math.min(slides.length-1,i)); cur=i;
      track.scrollTo({left:slides[i].offsetLeft-track.offsetLeft,behavior:smooth===false?'auto':'smooth'}); mark(i); }
    thumbs.forEach(function(t,k){ t.addEventListener('click',function(){ go(k); }); });
    if(prev)prev.addEventListener('click',function(){ go(cur-1); });
    if(next)next.addEventListener('click',function(){ go(cur+1); });
    var to=null;
    if(track)track.addEventListener('scroll',function(){ clearTimeout(to); to=setTimeout(function(){
      var w=track.clientWidth||1, best=Math.round(track.scrollLeft/w); if(best!==cur&&slides[best]){ cur=best; mark(best); } },60); },{passive:true});
    /* hauteur de la colonne de vignettes = hauteur de la photo (ordinateur) */
    var gal=root.querySelector('[data-vf-gal]'), main=root.querySelector('.vf03-main');
    function sizeThumbs(){ if(gal&&main) gal.style.setProperty('--vf-gal-h',main.offsetHeight+'px'); }
    sizeThumbs(); window.addEventListener('resize',sizeThumbs);
    if(window.ResizeObserver&&main) new ResizeObserver(sizeThumbs).observe(main);
    mark(0);

    /* ---------- agrandissement ---------- */
    var lb=root.querySelector('[data-vf-lb]'), lbImg=root.querySelector('[data-vf-lb-img]'), lbI=0;
    function lbShow(i){ lbI=(i+slides.length)%slides.length; var im=slides[lbI].querySelector('img'); if(!im)return;
      var src=im.currentSrc||im.src; lbImg.src=src.replace(/([?&])width=\d+/,'$1width=2000'); lbImg.alt=im.alt||''; }
    slides.forEach(function(s,k){ s.addEventListener('click',function(){ if(!lb)return; lbShow(k); lb.hidden=false; document.documentElement.style.overflow='hidden'; }); });
    function lbClose(){ lb.hidden=true; document.documentElement.style.removeProperty('overflow'); go(lbI,false); }
    if(lb){
      root.querySelector('[data-vf-lb-x]').addEventListener('click',lbClose);
      root.querySelector('[data-vf-lb-prev]').addEventListener('click',function(){ lbShow(lbI-1); });
      root.querySelector('[data-vf-lb-next]').addEventListener('click',function(){ lbShow(lbI+1); });
      lb.addEventListener('click',function(e){ if(e.target===lb)lbClose(); });
      document.addEventListener('keydown',function(e){ if(lb.hidden)return; if(e.key==='Escape')lbClose(); if(e.key==='ArrowLeft')lbShow(lbI-1); if(e.key==='ArrowRight')lbShow(lbI+1); });
    }

    /* ---------- mini avis (1 par vue, flèches, la page ne bouge pas) ---------- */
    [].slice.call(root.querySelectorAll('[data-vf-rev]')).forEach(function(r){
      var t=r.querySelector('[data-vf-rev-track]'), n=t?t.children.length:0, i=0;
      var p=r.querySelector('[data-vf-rev-prev]'), q=r.querySelector('[data-vf-rev-next]');
      function show(){ t.style.transform='translate3d('+(-100*i)+'%,0,0)'; if(p)p.disabled=i===0; if(q)q.disabled=i>=n-1; }
      if(p)p.addEventListener('click',function(){ if(i>0){i--;show();} });
      if(q)q.addEventListener('click',function(){ if(i<n-1){i++;show();} });
      var x0=null; r.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
      r.addEventListener('touchend',function(e){ if(x0===null)return; var d=e.changedTouches[0].clientX-x0; x0=null; if(d<-40&&i<n-1){i++;show();} else if(d>40&&i>0){i--;show();} },{passive:true});
      show();
    });

    /* ---------- place réservée aux « prodotti abbinati » Moon : rendue dès que Moon a dessiné ---------- */
    [].slice.call(root.querySelectorAll('[data-vf-moon]')).forEach(function(m){
      var abb=m.nextElementSibling; if(!abb||!abb.hasAttribute('data-vf-abb'))return;
      function check(){
        if(m.querySelector('[class*="moonbundle-upsell"]')){ abb.classList.add('is-done'); return true; }
        if(m.querySelector('[class*="moonbundle-option"]')){ setTimeout(function(){ abb.classList.add('is-done'); },1500); return true; }
        return false;
      }
      if(!check()){ var mo=new MutationObserver(function(){ if(check())mo.disconnect(); }); mo.observe(m,{childList:true,subtree:true}); }
    });

    /* ---------- bouton d'ajout : un seul appel, Moon intercepte et ouvre son panier ---------- */
    /* 17/10 : écouteur posé sur la section (il marche aussi si le bouton est remis) + garde : le bouton ne peut plus être
       caché ni retiré (Malone : « le bouton disparaît après un premier ajout », vu dans l'éditeur) */
    var buyWrap=root.querySelector('.vf03-buy'), buyHTML='', gT=null;
    function guard(){ gT=null;
      if(!buyWrap||!buyWrap.isConnected)buyWrap=root.querySelector('.vf03-buy'); if(!buyWrap)return;
      var b=buyWrap.querySelector('[data-vf-add]');
      if(b)buyHTML=buyWrap.innerHTML; else if(buyHTML)buyWrap.innerHTML=buyHTML;
      [buyWrap,buyWrap.querySelector('form'),buyWrap.querySelector('[data-vf-add]')].forEach(function(el){ if(!el)return;
        if(el.hidden)el.hidden=false;
        ['display','visibility','opacity'].forEach(function(p){ if(el.style.getPropertyValue(p))el.style.removeProperty(p); }); });
    }
    if(buyWrap){ guard(); new MutationObserver(function(){ if(!gT)gT=setTimeout(guard,50); }).observe(buyWrap.parentNode||root,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','class']});
      setInterval(guard,1500); }
    var form=root.querySelector('form[data-vf-form]');
    if(form){
      root.addEventListener('submit',function(e){
        var form=e.target; if(!form.matches||!form.matches('form[data-vf-form]'))return;
        e.preventDefault();
        var btn=form.querySelector('[data-vf-add]'); if(!btn||btn.dataset.busy)return;
        btn.dataset.busy='1';
        fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
          .then(function(r){ if(!r.ok)throw r; return r.json(); })
          .then(function(){
            delete btn.dataset.busy; btn.dataset.done='1'; setTimeout(function(){ delete btn.dataset.done; },1600);
            if(form.dataset.go==='checkout'){ window.location.href='/checkout'; return; }
            if(!window.openMoonBundleCartDrawer){ /* sans Moon : le panier du thème */ document.dispatchEvent(new CustomEvent('cart:refresh')); }
          })
          .catch(function(){ delete btn.dataset.busy; form.submit(); });
      });
    }

    /* ---------- barre d'achat fixe : visible quand le bouton principal n'est pas à l'écran ---------- */
    var bar=root.querySelector('[data-vf-bar]'), mainBtn=root.querySelector('[data-vf-add]');
    if(bar&&mainBtn){
      var bb=bar.querySelector('[data-vf-bar-btn]');
      /* 17/10 : après un ajout au panier le bouton principal est remplacé par un neuf → on le recherche à chaque fois
         (sinon la barre surveillait l'ancien, disparu, et ne revenait plus) */
      function cur(){ var m=root.querySelector('[data-vf-add]'); if(m)mainBtn=m; return mainBtn; }
      bb.addEventListener('click',function(){ cur().click(); });
      var tick=null, bp=bar.querySelector('.vf03-bar-price');
      /* 17/10 : la barre n'apparaît qu'une fois le bouton principal dépassé (page descendue sous lui), jamais au-dessus */
      function upd(){ tick=null; var r=cur().getBoundingClientRect();
        var on=r.width>0&&r.bottom<0; bar.classList.toggle('is-on',on); bar.setAttribute('aria-hidden',on?'false':'true'); bb.tabIndex=on?0:-1;
        if(on)offer(); }
      /* l'offre cochée dans le lot Moon (nom, prix, prix barré), recopiée dans la barre */
      function offer(){ var a=root.querySelector('[data-vf-moon] .moonbundle-option-active'); if(!a||!bp)return;
        var tx=function(s){ var e=a.querySelector(s); return e?e.textContent.trim():''; };
        var n=tx('.moonbundle-option-title span'), p=tx('.moonbundle-option-single-price'), o=tx('.moonbundle-option-old-price');
        var sig=n+'|'+p+'|'+o; if(!p||bp.dataset.sig===sig)return; bp.dataset.sig=sig; bp.textContent='';
        [['em',n],['s',o],['span',p]].forEach(function(x){ if(!x[1])return; var el=document.createElement(x[0]); el.textContent=x[1]; bp.appendChild(el); }); }
      /* écoute en capture sur le document : après la fermeture du panier, MoonCart met overflow:auto sur html et body,
         c'est alors <body> qui défile et la fenêtre ne reçoit plus « scroll » */
      document.addEventListener('scroll',function(){ if(!tick)tick=setTimeout(upd,60); },{passive:true,capture:true});
      window.addEventListener('resize',upd); setTimeout(upd,300);
      root.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('[data-vf-moon]'))setTimeout(offer,120); });
    }

    /* ---------- 17/10 : « L'80% delle clienti lo abbina a: » sous le mini-carrousel d'avis (Malone) ----------
       Les vraies cases de Moon restent dans le lot (cachées) : chaque bouton « AGGIUNGI » appuie sur la vraie case,
       donc le bouton d'achat envoie toujours l'offre + les produits choisis, comme avant. */
    var ups=null, upsTrack=null, upsSig='', uT=null;
    function upsEnsure(){
      if(ups&&ups.isConnected)return true;
      var rev=root.querySelector('[data-vf-rev]'), after=rev?rev.closest('.vf03-b')||rev:null;
      if(!after)after=root.querySelector('.vf03-buy'); if(!after)return false;
      ups=document.createElement('div'); ups.className='vf03-b vf03-ups'; ups.setAttribute('data-vf-ups','');
      ups.innerHTML='<div class="vf03-ups-head"><p class="vf03-ups-t"></p><div class="vf03-ups-nav"><button type="button" aria-label="Precedente" data-d="-1">&#8249;</button><button type="button" aria-label="Successivo" data-d="1">&#8250;</button></div></div><div class="vf03-ups-track" data-vf-ups-track></div>';
      ups.querySelector('.vf03-ups-t').textContent="L'80% delle clienti lo abbina a:";
      upsTrack=ups.querySelector('[data-vf-ups-track]'); upsSig='';
      ups.querySelectorAll('.vf03-ups-nav button').forEach(function(b){ b.addEventListener('click',function(){
        var c=upsTrack.firstElementChild, w=(c?c.getBoundingClientRect().width:150)+12;
        upsTrack.scrollBy({left:w*Number(b.getAttribute('data-d')),behavior:'smooth'}); }); });
      upsTrack.addEventListener('scroll',upsNav,{passive:true});
      after.parentNode.insertBefore(ups,after.nextSibling);
      return true;
    }
    function upsNav(){ if(!ups)return; var b=ups.querySelectorAll('.vf03-ups-nav button'), max=upsTrack.scrollWidth-upsTrack.clientWidth;
      ups.querySelector('.vf03-ups-nav').style.visibility=max>4?'visible':'hidden'; b[0].disabled=upsTrack.scrollLeft<=4; b[1].disabled=upsTrack.scrollLeft>=max-4; }
    function upsSync(){ uT=null;
      var real=[].slice.call(root.querySelectorAll('[data-vf-moon] .moonbundle-upsell-item[data-upsell-id]'));
      if(!real.length){ if(ups)ups.hidden=true; return; }
      if(!upsEnsure())return; ups.hidden=false;
      var sig=real.map(function(it){ return it.getAttribute('data-upsell-id'); }).join('|');
      if(sig!==upsSig){ upsSig=sig; upsTrack.textContent='';
        real.forEach(function(it){
          var id=it.getAttribute('data-upsell-id'), im=it.querySelector('img'), tx=function(s){ var e=it.querySelector(s); return e?e.textContent.trim():''; };
          var c=document.createElement('div'); c.className='vf03-up'; c.setAttribute('data-id',id);
          c.innerHTML='<div class="vf03-up-img"><img alt="" loading="lazy" width="300" height="300"></div><p class="vf03-up-n"></p><p class="vf03-up-p"><s></s><span></span></p><button type="button" class="vf03-up-btn"></button>';
          if(im){ c.querySelector('img').src=im.currentSrc||im.src; c.querySelector('img').alt=im.alt||''; }
          c.querySelector('.vf03-up-n').textContent=tx('.moonbundle-upsell-title-text');
          c.querySelector('.vf03-up-p s').textContent=tx('.moonbundle-upsell-original-price');
          c.querySelector('.vf03-up-p span').textContent=tx('.moonbundle-upsell-price');
          c.querySelector('.vf03-up-btn').addEventListener('click',function(){
            var inp=root.querySelector('[data-vf-moon] input[data-upsell-id="'+id+'"]'); if(inp)inp.click(); setTimeout(upsSync,40); });
          upsTrack.appendChild(c);
        });
        setTimeout(upsNav,50);
      }
      real.forEach(function(it){ var id=it.getAttribute('data-upsell-id'), inp=it.querySelector('input'), c=upsTrack.querySelector('[data-id="'+id+'"]');
        if(c){ var on=!!(inp&&inp.checked); c.classList.toggle('is-on',on); c.querySelector('.vf03-up-btn').textContent=on?'✓ AGGIUNTO':'AGGIUNGI'; } });
    }
    var moonEl=root.querySelector('[data-vf-moon]');
    if(moonEl){ new MutationObserver(function(){ if(!uT)uT=setTimeout(upsSync,80); }).observe(moonEl,{childList:true,subtree:true});
      moonEl.addEventListener('change',function(){ setTimeout(upsSync,20); }); upsSync(); window.addEventListener('resize',upsNav); }

    /* ---------- MoonCart pose overflow:auto !important sur <html>/<body> en fermant son tiroir → plus rien ne colle ---------- */
    function unAuto(el){ if(el.style.overflow==='auto')el.style.removeProperty('overflow'); }
    [document.documentElement,document.body].forEach(function(el){ new MutationObserver(function(){ unAuto(el); }).observe(el,{attributes:true,attributeFilter:['style']}); });
  }
  function all(){ [].slice.call(document.querySelectorAll('[data-vf03]')).forEach(init); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all); else all();
  document.addEventListener('shopify:section:load',all);
})();
